import React, { useContext, useState } from "react";
import {Button, Col, Row} from "reactstrap";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";
import { Presentation } from "../types/presentation";
import EventContext from "../contexts/event";
import UserContext from "../contexts/user";

const MobileBottomNav = ({
                    presentation,
                    setShowForumSidebar,
                    tab

                }: {
    presentation: Presentation;
    setShowForumSidebar?: (arg0: any) => void;
    tab: number;

}) => {
    const eventContext = useContext(EventContext);
    const userContext = useContext(UserContext);
    const history = useHistory();
    const intl = useIntl();
    const [selectTab, setSelectTab] = useState(tab);



    // @ts-ignore
    return (
        <Row className="top-menu-container fixed-to-left">
            <Col md></Col>
            <Col md></Col>
            <Col lg={6} xl={4}>
                {
                    (eventContext.forum || eventContext.quiz) &&
                    <div>
                        <div className="top-menu pad-0 top-menu-mob">

                            <Button onClick={() => history.push(`/${eventContext.slug}`)}
                                    color="primary" className="back-to-main d-block d-lg-none">
                                <img src="/icons/arrow-back-white.svg" alt="back"/>
                            </Button>

                            {eventContext.forum && (
                                <Button color="primary"  className={`${selectTab === 1 ? "active" : ""} nav-link d-block d-lg-none`}
                                        onClick={() => {
                                         setSelectTab(1)
                                         setShowForumSidebar && setShowForumSidebar(true)
                                         history.push(`/${eventContext.slug}/${presentation._id}/forum${document.location.search}`)
                                        }}>
                                    <img className="d-none d-lg-block" src="/icons/forum-ico.svg"
                                         alt="forum"/>
                                    <img className="d-block d-lg-none" src="/icons/forum-ico-mob.svg"
                                         alt="forum"/>
                                    <span>Forum</span>
                                </Button>)}

                            {
                                eventContext.quiz &&
                                <Button color="primary" className={`${selectTab === 2 ? "active" : ""} nav-link d-block d-lg-none`}
                                        onClick={() => {
                                            setSelectTab(2);
                                            userContext.user ?
                                                history.push(`/${eventContext.slug}/${presentation._id}/quiz${document.location.search}`)
                                                :
                                                userContext.setShowLogin(true)
                                        }}><img className="d-none d-lg-block" src="/icons/quiz-ico.svg"
                                                alt="quiz"/><img className="d-block d-lg-none"
                                                                 src="/icons/quiz-ico-mob.svg"
                                                                 alt="quiz"/>
                                    <span>Quiz</span>
                                </Button>
                            }

                            {
                                eventContext.presentationsWithResults.indexOf(presentation._id) > -1 &&
                                <Button color="primary"  className={`${selectTab === 3 ? "active" : ""} nav-link d-block d-lg-none`}
                                        onClick={() => {
                                            setSelectTab(3);
                                            history.push(`/${eventContext.slug}/${presentation._id}/quiz-results${document.location.search}`)
                                        }}>
                                    <img className="d-block d-lg-none" src="/icons/podium-ico.svg"
                                         alt="quiz"/>
                                </Button>
                            }
                            {
                                (eventContext.quiz && userContext.user?.is_moderator === true) &&
                                <Button color="primary"  className={`${selectTab === 4 ? "active" : ""} nav-link d-block d-lg-none`}
                                        onClick={() => {
                                            setSelectTab(4);
                                            userContext.user
                                                ? history.push(
                                                    `/${eventContext.slug}/${presentation._id}/quiz-moderator${document.location.search}`
                                                )
                                                : userContext.setShowLogin(true);
                                        }}>
                                    <img className="d-block d-lg-none" src="/icons/edit_icon.svg"
                                         alt="quiz"/>
                                </Button>
                            }

                            {/* TODO: WIP
                    { userContext.user?.moderator && <Button color="primary" className="nav-link d-block d-lg-none" onClick={() => { history.push(`/${eventContext.slug}/${ppt._id}/quiz-moderator${document.location.search}`) }}><img className="d-block d-lg-none" src="/icons/quiz-ico-mob.svg" alt="quiz" /></Button> } */}

                            <Button  className={`${selectTab === 5 ? "active" : ""} nav-link d-block d-lg-none`}
                                    onClick={() => {
                                        setSelectTab(5);
                                        setShowForumSidebar && setShowForumSidebar(false)
                                            history.push(`/${eventContext.slug}/${presentation._id}${document.location.search}`)
                                    }
                            }>
                                <img className="d-none d-lg-block" src="/icons/video-ico.svg"
                                     alt="watch video"/>
                                <img className="d-block d-lg-none" src="/icons/video-ico-mob.svg"
                                     alt="watch video"/>
                                <span>Watch Video</span>
                            </Button>

                        </div>
                    </div>

                }
            </Col>
        </Row>
    );
};

export default MobileBottomNav;
